import { render, staticRenderFns } from "./showPpt.vue?vue&type=template&id=154de7a4&scoped=true"
import script from "./showPpt.vue?vue&type=script&lang=js"
export * from "./showPpt.vue?vue&type=script&lang=js"
import style0 from "./showPpt.vue?vue&type=style&index=0&id=154de7a4&prod&lang=css"
import style1 from "./showPpt.vue?vue&type=style&index=1&id=154de7a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154de7a4",
  null
  
)

export default component.exports